import React from 'react';
import PropTypes from 'prop-types';
import ThresholdRangeTypes
  from '@avtechsoftware/ra-javascript-utilities/src/types/ThresholdRangeTypes';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import CrudItemContextMenu from '../../../common/RaaLists/CrudItemContextMenu/CrudItemContextMenu';

function ThresholdRangeTableRow({
  thresholdRange,
  hasEditPrivileges,
  onEdit,
  onDelete,
  onClone,
  onView,
}) {
  const {
    name,
    displayName,
    typeId,
    displayValue,
    numUsedDisplay,
  } = thresholdRange;

  return (
    <tr
      className="avt-table-row"
      onClick={onView}
      style={{ cursor: 'pointer' }}
    >
      <td>
        {typeId === ThresholdRangeTypes.PREDEFINED && (<Icon icon="shield" title="Predefined Threshold Range" />)}
      </td>
      <td
        className="ellipsis width-25"
        title={name}
        onClick={(e) => typeId === ThresholdRangeTypes.PREDEFINED && e.stopPropagation()}
      >
        <span className="ml-1">{displayName}</span>
      </td>
      <td className="ellipsis width-25" title={displayValue}>
        <span>{displayValue}</span>
      </td>
      <td className="ellipsis width-25" title={numUsedDisplay}>
        <span>{numUsedDisplay}</span>
      </td>
      <td
        className="text-right pr-5 width-10"
        onClick={(e) => e.stopPropagation()}
      >
        <CrudItemContextMenu
          onEditClick={onEdit}
          onDeleteClick={onDelete}
          onCloneClick={onClone}
          onViewClick={onView}
          hasEditPrivileges={hasEditPrivileges}
          rowData={thresholdRange}
        />
      </td>
    </tr>
  );
}

ThresholdRangeTableRow.propTypes = {
  thresholdRange: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    displayName: PropTypes.node.isRequired,
    typeId: PropTypes.number.isRequired,
    displayValue: PropTypes.string.isRequired,
    numUsedDisplay: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
  }).isRequired,
  hasEditPrivileges: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onClone: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
};

export default ThresholdRangeTableRow;
